import { User } from "lucide-react";

const ExpertSection = () => (
  <section className="border-t border-border/30 bg-card/30 py-10 md:py-14">
    <div className="container">
      <div className="mx-auto max-w-2xl">
        <div className="flex items-start gap-4">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
            <User className="h-6 w-6" aria-hidden="true" />
          </div>
          <div>
            <h3 className="font-display text-base font-semibold text-foreground sm:text-lg">
              Geprüft von einem Longevity-Experten
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              Benedikt Keck ist Longevity-Experte bei{" "}
              <a
                href="https://www.longevity-hackers.de/about"
                target="_blank"
                rel="noopener"
                className="text-primary underline underline-offset-2 hover:text-primary/80"
              >
                Longevity Hackers
              </a>
              . Er hat über 200&nbsp;Biomarker dokumentiert und mehr als 300&nbsp;Produkte persönlich getestet. Die heilys Rotlichtgeräte sind fester Bestandteil seines täglichen Therapie-Protokolls — er nutzt sie in Kombination mit MITO&nbsp;LIGHT Panels für optimale Ergebnisse.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ExpertSection;
